import smoothscroll from 'smoothscroll-polyfill';
import "./Header";
import "./Menu";
import "./packageTabs";
import "./NewsLoader";
import "./Accordion";
import "./Emergency";
import "./gravityForm";
import "./Cookiebar";
import "./pageScroll";

// Slider
import "./slider";
// kick off the polyfill for smooth scrolling
smoothscroll.polyfill();
